import React from "react";
import { services } from "../../data/SiteData";
function Services(props) {
  return (
    <section id="services" class="services">
      <div class="container">
        <div class="section-title">
          <span>Services</span>
          <h2>Services</h2>
          <p>ADVANCE BEYOND CREATIVITY: EXPERIENCE IT!</p>
        </div>

        <div class="row">
          {services.map((item) => {
            return (
              <div
                class="col-lg-4 col-md-6 d-flex align-items-stretch"
                data-aos="fade-up"
              >
                <div class="icon-box">
                  <div class="icon">
                    <i class={item.icon}></i>
                  </div>
                  <h4>
                    <a href={item.link}>{item.title}</a>
                  </h4>
                  <p>{item.description}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}

export default Services;
